import { render, staticRenderFns } from "./CheerUpArea.vue?vue&type=template&id=70edfd42&scoped=true&"
import script from "./CheerUpArea.vue?vue&type=script&lang=js&"
export * from "./CheerUpArea.vue?vue&type=script&lang=js&"
import style0 from "./CheerUpArea.vue?vue&type=style&index=0&id=70edfd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70edfd42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
